<template>
<div>
    <b-carousel id="carousel-1" v-model="slide" :interval="4000" controls indicators background="#ababab" img-width="1024" img-height="480" style="text-shadow: 1px 1px 2px #333" @sliding-start="onSlideStart" @sliding-end="onSlideEnd">
        <!-- Text slides with image -->
            <b-carousel-slide v-if="langfrench" v-for="(slided, index) in slideData" :caption="slided.title_caption" :text="slided.caption" :img-src="wurl + '/imgsrv/' + slided.slide_file" @click="gotoclickedslide()">
        </b-carousel-slide>
            <b-carousel-slide v-else v-for="(slided, index) in slideData" :caption="slided.title_caption_va" :text="slided.caption_va" :img-src="wurl + '/imgsrv/' + slided.slide_file_va" @click="gotoclickedslide()">
        </b-carousel-slide>
    </b-carousel>

    <div class="headlinehome">
        <div class="row">
            <b-container class="mx-auto">
                <b-row>
                    <b-col v-for="(portfolioh, index) in portfoliohighlight" lg="4" md="6" sm="6" xs="12" ml-md-auto class="d-flex justify-content-center mb-3">
                       
                        <div @click="clickedToViewinModal(index, portfolioh.categorie)">
                            <div class="picportfoliohome shadow">
                                <div v-if="langfrench">
                                    <b-img :src="wurl + '/imgsrv/' + portfolioh.portfolio_pic_fr" alt="Responsive image"></b-img>
                                    <div class="overlayonhover"></div>
                                    <div class="textcaption">
                                        <h3>{{ portfolioh.portfolio_title_fr }}</h3>
                                    </div>
                                    <div class="textinside">
                                        {{ portfolioh.portfolio_smalldescription_fr }}
                                    </div>
                                </div>
                                <div v-else>
                                    <b-img :src="wurl + '/imgsrv/' + portfolioh.portfolio_pic_en" alt="Responsive image"></b-img>
                                    <div class="overlayonhover"></div>
                                    <div class="textcaption">
                                        <h3>{{ portfolioh.portfolio_title_en }}</h3>
                                    </div>
                                    <div class="textinside">
                                        {{ portfolioh.portfolio_smalldescription_en }}
                                    </div>
                                </div>
                            </div>
                        </div>
                      </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
    <client></client>
    <div>
        <b-modal id="bv-modal-example" hide-footer size="portfolio" :title="this.title_in_modal">
            <b-row class="mainPortfolioContent">
                    <div>
                        <div v-if="categorieRadio">
                            <aplayer autoplay :music="{
    title: 'secret base~君がくれたもの~',
    artist: 'Silent Siren',
    src: link_for_audio_to_load_in_modal,
    pic: 'https://moeplayer.b0.upaiyun.com/aplayer/secretbase.jpg'
  }" />
                        </div>
                        <div v-else>
                            <b-img :src="wurl + '/imgsrv/' + this.pic_in_modal" fluid alt="Responsive image"></b-img>
                        </div>
                        <div class="maintPortfolioContentText">
                            <div v-html="text_in_modal"></div>
                        </div>
                    </div>
                </b-row>
            <b-button v-if="langfrench" class="mt-3" block @click="$bvModal.hide('bv-modal-example')">Fermer</b-button>
            <b-button v-else class="mt-3" block @click="$bvModal.hide('bv-modal-example')">Close</b-button>
        </b-modal>

    </div>
</div>
</template>

<script>
//bus for handling component interconnection
import {
    EventBus
} from "@/event-bus.js";
import axios from "axios";
import {
    globalSiteSetting
} from "../main.ts";

export default {
    data() {
        return {
            slide: 0,
            sliding: null,
            wurl: globalSiteSetting.siteurl,
            slideData: [],
            langfrench: true,
            categorieToView: '',
            categorieRadio: false,
            portfoliohighlight: [],
            title_in_modal: '',
            pic_in_modal: '',
            text_in_modal: '',
            link_for_audio_to_load_in_modal:''
        };
    },
    methods: {
        gotoclickedslide() {
            //console.log('yes clicked slide')
        },
        onSlideStart(slide) {
            this.sliding = true;
        },
        onSlideEnd(slide) {
            this.sliding = false;
        },
        clickedToViewinModal(i,cat) {
            //console.log('yes launch modal')///
            if (cat == 'radio') {
                this.categorieRadio = true
            }
            else {
                this.categorieRadio = false
            }
            this.$bvModal.show('bv-modal-example')
            if (this.langfrench == true) {
                this.title_in_modal = this.portfoliohighlight[i].portfolio_title_fr
                this.pic_in_modal = this.portfoliohighlight[i].portfolio_pic_detail_fr
                this.text_in_modal = this.portfoliohighlight[i].portfolio_content_fr
                this.audio_in_modal = this.portfoliohighlight[i].portfolio_audio_fr
            } else {
                this.title_in_modal = this.portfoliohighlight[i].portfolio_title_en
                this.pic_in_modal = this.portfoliohighlight[i].portfolio_pic_detail_en
                this.text_in_modal = this.portfoliohighlight[i].portfolio_content_en
                this.audio_in_modal = this.portfoliohighlight[i].portfolio_audio_en
            }
            //create audio link
                this.link_for_audio_to_load_in_modal = this.wurl+'/imgsrv/'+this.audio_in_modal
        },
        retrievedataforslide() {
            var app = this;
            var weburl = this.wurl;
            axios
                .get(weburl + "/api.data.php?req=dynamicdata&p=slide&auth=razafy", {
                    crossDomain: true,
                })
                .then((response) => {
                    //console.log('the response are:' + response.data[0].slide_file)
                    this.slideData = this.slideData.concat(response.data);
                });
        },
        retrievedataforhighlight() {
            var app = this;
            var weburl = this.wurl;
            axios
                .get(weburl + "/api.data.php?req=dynamicdata&p=portfolio&q=homehighlight&auth=razafy", {
                    crossDomain: true,
                })
                .then((response) => {
                    //put result to available array
                    this.portfoliohighlight = this.portfoliohighlight.concat(
                        response.data
                    );
                });
        },

        clickedFromHome(ln) {

            //redirect link to click item
            this.$router.push({
                name: 'work',
                params: {
                    p: 'highlight',
                    i: ln
                }
            })
        },
        togglefrenchlangage() {
            this.langfrench = true
            //console.log('lang is now french')
            //change page title
            window.document.title = 'Graphikodesign'
        },
        toggleenglishlangage() {
            this.langfrench = false
            //console.log('lang is now english')
            //change page title
            window.document.title = 'Graphikodesign'
        },
         closemodal() {

            this.categorieRadio = false
            //console.log('modal was closed and categorieRadio:' + this.categorieRadio)

        },
        checkifcookieexistornot() {

            if (this.$cookie.get('gd_cookie') === 'accepted' || this.$cookie.get('gd_cookie') === 'rejected') {

                // try to read lang conf
                if (this.$cookie.get('gd_cookie') === 'accepted') {
                    if (this.$cookie.get('gd_langinfrench') === 'true') {
                        this.langfrench = true
                        EventBus.$emit('togglelangtofrench')
                    } else {
                        this.langfrench = false
                        EventBus.$emit('togglelangtoenglish')
                    }
                }
            }
        }
    },
    created() {
        this.retrievedataforslide();

    },
    mounted() {
         this.categorieToView = this.catToView
        this.retrievedataforhighlight();
        this.checkifcookieexistornot()

 //change page title
            window.document.title = 'Graphikodesign'

        //listen to langage change
        EventBus.$on('togglelangtofrench', () => {
            this.togglefrenchlangage()
        })
        EventBus.$on('togglelangtoenglish', () => {
            this.toggleenglishlangage()
        })
    }
};
</script>
